(function () {
  const navbar = document.getElementById("main-navbar");
  const title = document.getElementById("main-navbar-title");

  const btnToggle = document.getElementById("main-navigation-toggle");
  const btnClose = document.getElementById("main-navbar-close");
  const btnBack = document.getElementById("main-navbar-back");

  const menuItems = navbar.querySelectorAll("a");

  let openSubmenu = null;

  const handleNaigationOpen = () => {
    navbar.dataset.open = true;
    document.body.style.overflow = "hidden";
  };

  const handleNaigationClose = () => {
    navbar.dataset.open = false;
    document.body.style.overflow = "";

    navbar.addEventListener(
      "transitionend",
      () => {
        if (openSubmenu) {
          navbar.dataset.navbarSubmenuOpen = false;
          openSubmenu.dataset.open = false;
          openSubmenu.scrollTop = 0;
          openSubmenu = null;
        }
      },
      {
        once: true,
      }
    );
  };

  const hideSubmenu = () => {
    if (!openSubmenu) return;

    navbar.dataset.navbarSubmenuOpen = false;
    openSubmenu.dataset.open = false;

    openSubmenu.addEventListener(
      "transitionend",
      () => {
        title.removeAttribute("data-alt-title");
        openSubmenu.scrollTop = 0;
        openSubmenu = null;
      },
      { once: true }
    );
  };

  const showSubmenu = (subMenu) => {
    openSubmenu = subMenu;

    navbar.dataset.navbarSubmenuOpen = true;
    openSubmenu.dataset.open = true;
  };

  btnToggle.addEventListener("click", () => {
    if (navbar.dataset.open !== "true") {
      handleNaigationOpen();
      return;
    }
    handleNaigationClose();
  });

  btnClose.addEventListener("click", () => {
    handleNaigationClose();
  });

  // submenu handlers
  btnBack.addEventListener("click", () => hideSubmenu());

  for (const item of menuItems) {
    const sibling = item.nextElementSibling;
    if (!sibling || !sibling.classList.contains("sub-menu")) continue;

    item.addEventListener("click", (e) => {
      title.dataset.altTitle = e.target.textContent;
      showSubmenu(sibling);
      e.preventDefault();
    });
  }
})();
